import React from "react";
import { Pagination } from "antd";
import { useTranslation } from "react-i18next";

const PaginationView = ({
  current = 1,
  next = 1,
  pageSize = 2,
  total = 1,
  onChange,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <Pagination
        current={current}
        pageSize={pageSize}
        total={total}
        showTotal={(total) => (
          <div className="font-bold text-gray-900">
            {t("common.total")} : {total}
          </div>
        )}
        onChange={onChange}
      />
    </div>
  );
};

export default PaginationView;
